import { render, staticRenderFns } from "./BlackWhiteItem.vue?vue&type=template&id=2df962d4&scoped=true"
import script from "./BlackWhiteItem.vue?vue&type=script&lang=js"
export * from "./BlackWhiteItem.vue?vue&type=script&lang=js"
import style0 from "./BlackWhiteItem.vue?vue&type=style&index=0&id=2df962d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df962d4",
  null
  
)

export default component.exports